// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"f6598e60","505":"b5aa8c2b","801":"f6598e60"}[chunkId] + ".chunk.css";
};